export enum CardInfoStatus {
  unknown = 'Unknown',
  extraFile = 'extraFile',
  migrate = 'migrate',
  doNotMigrate = 'doNotMigrate',
}
